import { render, staticRenderFns } from "./SettingsLayout.vue?vue&type=template&id=64c6fbc9&scoped=true&"
import script from "./SettingsLayout.vue?vue&type=script&lang=js&"
export * from "./SettingsLayout.vue?vue&type=script&lang=js&"
import style0 from "./SettingsLayout.vue?vue&type=style&index=0&id=64c6fbc9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c6fbc9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64c6fbc9')) {
      api.createRecord('64c6fbc9', component.options)
    } else {
      api.reload('64c6fbc9', component.options)
    }
    module.hot.accept("./SettingsLayout.vue?vue&type=template&id=64c6fbc9&scoped=true&", function () {
      api.rerender('64c6fbc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/SettingsLayout.vue"
export default component.exports